import { useRouter } from 'expo-router';
import { View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

import { SearchTrigger } from '@/components/molecules';
import { ContactList } from '@/components/organisms';
import { useTranslation } from '@/i18n';

const headerStyle = {
  flexDirection: 'row',
  alignItems: 'center',
  paddingRight: 16,
} as const;

const searchContainerStyle = { flex: 1 } as const;

export const Contacts = () => {
  const router = useRouter();
  const insets = useSafeAreaInsets();
  const { t } = useTranslation();

  return (
    <View style={{ flex: 1, paddingTop: insets.top }}>
      <View style={headerStyle}>
        <View style={searchContainerStyle}>
          <SearchTrigger
            onPress={() => router.push('/search/contacts')}
            placeholder={t('common.search')}
          />
        </View>
      </View>
      <ContactList />
    </View>
  );
};
